import { MiniMessageActionTypes } from "../constants";

interface ShowMiniBoxMessageAction {
  type: "SHOW_MINI_MESSAGE_BOX";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showMiniBoxMessage = (data: Record<string, any>): ShowMiniBoxMessageAction => {
  return {
    type: MiniMessageActionTypes.SHOW_MINI_MESSAGE_BOX,
    payload: data,
  };
};

interface HideMiniBoxMessageAction {
  type: "HIDE_MINI_MESSAGE_BOX",
}

export const hideMiniBoxMessage = (): HideMiniBoxMessageAction => {
  return {
    type: MiniMessageActionTypes.HIDE_MINI_MESSAGE_BOX,
  };
};

export type Action = ShowMiniBoxMessageAction | HideMiniBoxMessageAction;
